import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FlyFreelyConstants } from '../constants';
import {
    CreateObjectiveCommand,
    MissionObjectiveDto,
    UpdateObjectiveCommand
} from '../model/api';
import { httpParamSerializer } from './service.helpers';

@Injectable({
    providedIn: 'root'
})
export class MissionObjectivesService {
    private baseUrl: string;
    private changeSource = new Subject<void>();
    change$ = this.changeSource.asObservable();

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.API_URL;
    }

    ngOnDestroy() {
        this.changeSource.complete();
    }

    find(organisationId: number, archived?: boolean) {
        return this.http.get<MissionObjectiveDto[]>(
            `${this.baseUrl}/webapi/missionObjectives`,
            {
                params: httpParamSerializer({ organisationId, archived })
            }
        );
    }

    create(command: CreateObjectiveCommand) {
        return this.http
            .post<MissionObjectiveDto>(
                `${this.baseUrl}/webapi/missionObjectives`,
                command
            )
            .pipe(tap(() => this.changeSource.next()));
    }

    update(missionObjectiveId: number, command: UpdateObjectiveCommand) {
        return this.http
            .put<MissionObjectiveDto>(
                `${this.baseUrl}/webapi/missionObjectives/${missionObjectiveId}`,
                command
            )
            .pipe(tap(() => this.changeSource.next()));
    }

    archive(missionObjectiveId: number) {
        return this.http
            .put<MissionObjectiveDto>(
                `${this.baseUrl}/webapi/missionObjectives/${missionObjectiveId}/archive`,
                null
            )
            .pipe(tap(() => this.changeSource.next()));
    }

    unarchive(missionObjectiveId: number) {
        return this.http
            .put<MissionObjectiveDto>(
                `${this.baseUrl}/webapi/missionObjectives/${missionObjectiveId}/unarchive`,
                null
            )
            .pipe(tap(() => this.changeSource.next()));
    }
}
